import React from 'react';

export default function Retry(props) {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
      <path
        d='m23.516 9.75.3-1.34.034-.12a1 1 0 0 1 1.917.557l-1.07 4.78-5.094-1.156-.12-.035a1 1 0 0 1 .563-1.915l1.84.416a8 8 0 1 0 1.86 8.026l.087-.288 1.974.363a9.97 9.97 0 0 1-4.673 6.122c-4.783 2.762-10.899 1.123-13.66-3.66-2.762-4.783-1.123-10.899 3.66-13.66 4.142-2.392 9.285-1.483 12.382 1.91z'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  );
}
